import i18next from 'i18next';
import cookie from 'cookie';

const SUPPORTED_LANGUAGES = ['en', 'fr'];

export function filterLanguage(language: string): string {
  if (language && SUPPORTED_LANGUAGES.includes(language)) {
    return language;
  }
  return null;
}

export function getLanguageFromLocale(locale: string): string {
  if (locale && locale.length >= 2) {
    return filterLanguage(locale.substring(0, 2));
  }
  return null;
}

export function getLanguageFromi18Next(): string {
  return getLanguageFromLocale(i18next.language);
}

export function getLanguageFromExtranetCookie(): string {
  const cookies = cookie.parse(document.cookie);
  if (!cookies.ee_language) return null;
  return getLanguageFromLocale(cookies.ee_language);
}

export function getLanguage(): string {
  let language = getLanguageFromi18Next();
  if (language !== null) return language;
  language = getLanguageFromExtranetCookie();
  if (language !== null) return language;
  return 'fr';
}
